/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AnyInputs */

const en_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any`)
};

const es_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquiera`)
};

const fr_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const de_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliebig`)
};

const ja_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定なし`)
};

const zh_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不限`)
};

const ar_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل`)
};

const id_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa saja`)
};

const it_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualsiasi`)
};

const ru_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любой`)
};

const pt_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer`)
};

const ko_any = /** @type {(inputs: AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체`)
};

/**
* | output |
* | --- |
* | "Any" |
*
* @param {AnyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const any = /** @type {((inputs?: AnyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AnyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_any(inputs)
	if (locale === "es") return es_any(inputs)
	if (locale === "fr") return fr_any(inputs)
	if (locale === "de") return de_any(inputs)
	if (locale === "ja") return ja_any(inputs)
	if (locale === "zh") return zh_any(inputs)
	if (locale === "ar") return ar_any(inputs)
	if (locale === "id") return id_any(inputs)
	if (locale === "it") return it_any(inputs)
	if (locale === "ru") return ru_any(inputs)
	if (locale === "pt") return pt_any(inputs)
	return ko_any(inputs)
});